<!-- SIDE PANEL -->
<ng-container
    *ngIf="
        !!appSession.userId && !fuseConfig.layout.sidepanel.hidden && fuseConfig.layout.sidepanel.position === 'left'
    "
>
    <!-- CHAT PANEL -->
    <fuse-sidebar
        name="chatPanel"
        position="left"
        class="chat-panel left-chat-panel"
        [folded]="true"
        [foldedWidth]="70"
        [foldedAutoTriggerOnHover]="false"
        lockedOpen="gt-md"
    >
        <!-- <chat-panel></chat-panel> -->
    </fuse-sidebar>
    <!-- / CHAT PANEL -->
</ng-container>
<!-- / SIDE PANEL -->

<div id="main" (click)="globalClick()">
    <!-- TOOLBAR: Above -->
    <ng-container *ngIf="fuseConfig.layout.toolbar.position === 'above'">
        @if (v2Enabled) {
        <ng-container *ngTemplateOutlet="v2Toolbar"></ng-container>
        }@else {
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
        }
    </ng-container>
    <!-- / TOOLBAR: Above -->

    <div id="container-1" class="container">
        <!-- NAVBAR: Left -->
        <ng-container *ngIf="fuseConfig.layout.navbar.position === 'left'">
            @if(v2Enabled) {
            <ng-container *ngTemplateOutlet="v2LeftNavbar"></ng-container>
            } @else {
            <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
            }
        </ng-container>
        <!-- / NAVBAR: Left -->

        <div id="container-2" class="container">
            <!-- TOOLBAR: Below fixed -->
            <ng-container *ngIf="fuseConfig.layout.toolbar.position === 'below-fixed'">
                @if (v2Enabled) {
                <ng-container>
                    <v2-toolbar></v2-toolbar>
                </ng-container>
                }@else {
                <ng-container *ngTemplateOutlet="toolbar"></ng-container>

                }
            </ng-container>
            <!-- / TOOLBAR: Below fixed -->

            <app-alert-component> </app-alert-component>

            <div
                id="container-3"
                class="container"
                fusePerfectScrollbar
                [fusePerfectScrollbarOptions]="{ suppressScrollX: true, updateOnRouteChange: true }"
            >
                <!-- TOOLBAR: Below static -->
                <ng-container *ngIf="fuseConfig.layout.toolbar.position === 'below-static'">
                    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
                </ng-container>
                <!-- / TOOLBAR: Below static -->

                <!-- CONTENT -->
                <content></content>
                <!-- / CONTENT -->

                <!-- FOOTER: Below static -->
                <ng-container *ngIf="fuseConfig.layout.footer.position === 'below-static'">
                    <ng-container *ngTemplateOutlet="footer"></ng-container>
                </ng-container>
                <!-- / FOOTER: Below static -->
            </div>

            <!-- FOOTER: Below fixed -->
            <ng-container *ngIf="fuseConfig.layout.footer.position === 'below-fixed'">
                <ng-container *ngTemplateOutlet="footer"></ng-container>
            </ng-container>
            <!-- / FOOTER: Below fixed -->
        </div>

        <!-- NAVBAR: Right -->
        <ng-container *ngIf="fuseConfig.layout.navbar.position === 'right'">
            <ng-container *ngTemplateOutlet="rightNavbar"></ng-container>
        </ng-container>
        <!-- / NAVBAR: Right -->
    </div>

    <!-- FOOTER: Above -->
    <ng-container *ngIf="fuseConfig.layout.footer.position === 'above'">
        <ng-container *ngTemplateOutlet="footer"></ng-container>
    </ng-container>
    <!-- FOOTER: Above -->
</div>

<!-- SIDE PANEL -->
<ng-container
    *ngIf="
        !!appSession.userId &&
        chatEnabled &&
        !fuseConfig.layout.sidepanel.hidden &&
        fuseConfig.layout.sidepanel.position === 'right'
    "
>
    <!-- CHAT PANEL -->
    <fuse-sidebar
        name="chatPanel"
        position="right"
        class="chat-panel right-chat-panel"
        [folded]="true"
        [foldedWidth]="70"
        [foldedAutoTriggerOnHover]="false"
        lockedOpen="gt-md"
    >
        <xmpp-chat></xmpp-chat>
    </fuse-sidebar>
    <!-- / CHAT PANEL -->
</ng-container>
<!-- / SIDE PANEL -->

<!-- QUICK PANEL -->
<fuse-sidebar name="quickPanel" position="right" class="quick-panel"> </fuse-sidebar>
<!-- / QUICK PANEL -->

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- @ PARTIALS
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- TOOLBAR -->
<ng-template #toolbar>
    <toolbar
        *ngIf="!fuseConfig.layout.toolbar.hidden"
        [ngClass]="[fuseConfig.layout.toolbar.position, fuseConfig.layout.toolbar.background]"
    ></toolbar>
</ng-template>
<!-- / TOOLBAR -->

<!-- V2 TOOLBAR -->
<ng-template #v2Toolbar>
    <v2-toolbar *ngIf="!fuseConfig.layout.toolbar.hidden"></v2-toolbar>
</ng-template>
<!-- / V2 TOOLBAR -->

<!-- FOOTER -->
<ng-template #footer>
    <footer
        *ngIf="!fuseConfig.layout.footer.hidden"
        [ngClass]="[fuseConfig.layout.footer.position, fuseConfig.layout.footer.background]"
    ></footer>
</ng-template>
<!-- / FOOTER -->

<!-- LEFT NAVBAR -->
<ng-template #leftNavbar>
    <fuse-sidebar
        (foldedChanged)="onNavbarFoldedChanged($event)"
        (openedChanged)="onNavbarOpenedChanged($event)"
        name="main-navbar"
        class="navbar-fuse-sidebar"
        [folded]="fuseConfig.layout.navbar.folded"
        lockedOpen="gt-md"
        *ngIf="!fuseConfig.layout.navbar.hidden"
    >
        <navbar
            [variant]="fuseConfig.layout.navbar.variant"
            class="left-navbar"
            [ngClass]="fuseConfig.layout.navbar.background"
        ></navbar>
    </fuse-sidebar>
</ng-template>
<!-- / LEFT NAVBAR -->

<!-- V2 LEFT NAVBAR -->
<ng-template #v2LeftNavbar>
    <fuse-sidebar
        (foldedChanged)="onNavbarFoldedChanged($event)"
        (openedChanged)="onNavbarOpenedChanged($event)"
        name="main-navbar"
        class="navbar-fuse-sidebar v2-navbar"
        [folded]="fuseConfig.layout.navbar.folded"
        lockedOpen="gt-md"
        *ngIf="!fuseConfig.layout.navbar.hidden"
    >
        <v2-navbar class="left-navbar"></v2-navbar>
    </fuse-sidebar>
</ng-template>
<!-- / V2 LEFT NAVBAR -->

<!-- RIGHT NAVBAR -->
<ng-template #rightNavbar>
    <fuse-sidebar
        name="navbar"
        position="right"
        class="navbar-fuse-sidebar"
        [folded]="fuseConfig.layout.navbar.folded"
        lockedOpen="gt-md"
        *ngIf="!fuseConfig.layout.navbar.hidden"
    >
        <navbar
            [variant]="fuseConfig.layout.navbar.variant"
            class="right-navbar"
            [ngClass]="fuseConfig.layout.navbar.background"
        ></navbar>
    </fuse-sidebar>
</ng-template>
<!-- / RIGHT NAVBAR -->
